export default __webpack_public_path__ + "static/build_game-72bf050e0fefe5791d0b8a8fcfe2f4d8.webp";